import type * as THREE from 'three';

export interface ScanReviewRecordsFactory {
    (): ScanReviewRecords;
}

export interface ScanReviewRecords {
    lowerJaw: ScanReviewRecord | null;
    upperJaw: ScanReviewRecord | null;
}

export interface ScanReviewRecordFactory {
    (): ScanReviewRecord | null;
}

export class ScanReviewRecord {
    constructor(
        public readonly scanMesh: THREE.Mesh<THREE.BufferGeometry, THREE.Material>,
        public readonly scanMeshTexture: THREE.Texture,
        public readonly scanMeshMaterial: THREE.Material,
        public readonly scanMeshStoneMaterial?: THREE.Material,
        public readonly scanMeshHeatMapMaterial?: THREE.Material,
        public readonly updateHeatMapRange?: (vMin: number, vMax: number) => void,
    ) {}

    setVisible(visible: boolean) {
        this.scanMesh.visible = visible;
    }

    setScanDisplay() {
        this.scanMesh.material = this.scanMeshMaterial;
    }

    setStoneModelDisplay() {
        if (this.scanMeshStoneMaterial) {
            this.scanMesh.material = this.scanMeshStoneMaterial;
        }
    }

    setHeatMapDisplay() {
        if (this.scanMeshHeatMapMaterial) {
            this.scanMesh.material = this.scanMeshHeatMapMaterial;
        }
    }
}
